import { render } from "./SitzungAntraegeGoToBox.pug?vue&type=template&id=c8e078ec&lang=pug"
import script from "./SitzungAntraegeGoToBox.js?vue&type=script&lang=js"
export * from "./SitzungAntraegeGoToBox.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__